import React from "react";
import { Link } from "react-router-dom";
import ServerImage from "components/server-image/server-image";
import { useTranslation } from "react-i18next";
const ProductsWaits = ({ apptags }) => {
  const { t } = useTranslation("home");

  let fourItems = apptags?.slice(3, 4);
  return (
    <div className="ProductsWaits">
      <h2>+{fourItems.length} {t("productWait")}</h2>
      <div className="all">
        {fourItems?.map((item) => (
          <Link to={`/app/${item?.id}`} key={item?.id}>
            <ServerImage src={item?.logo?.fullPath} alt={item?.logo?.name}  />
          </Link>
        ))}

        {apptags.length > 4 && (
          <Link to="/browse-apps" className="span-all">
            +{apptags.length - 4}
          </Link>
        )}
      </div>
    </div>
  );
};

export default ProductsWaits;
